import React, { useState, useEffect } from "react";
import { useAuth } from "../context/auth";
import axios from "axios";

const CountdownTimer = ({
  initialSeconds = 3600,
  onComplete,
  setWelcomeDiscountAmount,
  storageKey = "countdown", // New prop for unique key
}) => {
  const [auth] = useAuth();
  const userId = auth?.user?.id;
  const welcomeUsed = auth?.user?.welcome_discount_use === 1;

  const storedCountdown = parseInt(localStorage.getItem(storageKey), 10);
  const initialSecondsVerify = welcomeUsed ? 0 : initialSeconds;

  const [timeLeft, setTimeLeft] = useState(
    !isNaN(storedCountdown)
      ? storedCountdown
      : welcomeUsed
      ? 0
      : initialSecondsVerify
  );
  const [showCounter, setShowCounter] = useState(
    !isNaN(storedCountdown) ? true : !!initialSecondsVerify
  );

  const updateUser = async ({ key, value, id }) => {
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/customer/userUpdate`,
        { key, value, id }
      );

      if (data?.status) {
        console.log("User updated successfully");
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  useEffect(() => {
    if (welcomeUsed) {
      //localStorage.setItem(storageKey, 0);
      return;
    }

    if (!userId || !showCounter) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1;

        if (newTime <= 0) {
          updateUser({ key: "welcome_discount_use", value: 1, id: userId });

          const authData = JSON.parse(localStorage.getItem("auth"));
          if (authData?.user) {
            authData.user.welcome_discount_use = 1;
            localStorage.setItem("auth", JSON.stringify(authData));
          }

          localStorage.removeItem(storageKey);
          setShowCounter(false);
          clearInterval(timer);
          onComplete?.();
          return 0;
        }

        localStorage.setItem(storageKey, newTime);
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [userId, showCounter, onComplete, auth, welcomeUsed, storageKey, setWelcomeDiscountAmount]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <>
      {showCounter && userId && timeLeft > 1 && (
        <span className="text-center countdowntimer">
          {formatTime(timeLeft)}
        </span>
      )}
    </>
  );
};

export default CountdownTimer;
